import React, { useEffect, useState, useContext } from "react";
import "./AddVenue.css";
import { useLocation, useNavigate } from "react-router-dom";
import CurrentStep from "./CurrentStep";
import Loading from "../../components/Loader";
import { ToastContainer } from "react-toastify";
import Success from "./Success";
import { useTranslation } from 'react-i18next';
import AuthContext from "../../contexts/AuthProvider";

import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

const StepThree = ({ update, status, setStatus }) => {
  const { t } = useTranslation("addvenue");
  const navigate = useNavigate();
  const location = useLocation();
  const id = localStorage.getItem("venueId");
  const { isAuthenticated } = useContext(AuthContext);

  const searchParams = new URLSearchParams(location.search);
  const [editVenue, setEditVenue] = useState(searchParams.get("edit") === "true");
   const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  useEffect(() => {
    setEditVenue(searchParams.get("edit") === "true");
  }, [searchParams]);

  useEffect(() => {
    if (status === "Success") {
      const timer = setTimeout(() => {
        setStatus("");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [status, setStatus]);

  const [amenitiesList, setAmenitiesList] = useState([]);
  const [selectedAmenities, setSelectedAmenities] = useState(() => {
    try {
      const saved = localStorage.getItem("selectedAmenities");
      const parsed = saved ? JSON.parse(saved) : [];
      return Array.isArray(parsed) ? parsed.map((x) => (typeof x === "number" ? x : parseInt(x, 10))).filter((n) => !isNaN(n)) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    fetch(`${baseUrl}/api/v1/amenities`, {
      credentials: "include",
      headers: { Accept: "application/json", lang: getLangFromLocalStorage() },
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error("Failed to fetch amenities"))))
      .then((data) => setAmenitiesList(data.data || data || []))
      .catch(() => setAmenitiesList([]));
  }, []);

  const handleAmenityClick = (amenityId) => {
    setSelectedAmenities((prev) =>
      prev.includes(amenityId)
        ? prev.filter((id) => id !== amenityId)
        : [...prev, amenityId]
    );
  };

  useEffect(() => {
    localStorage.setItem("selectedAmenities", JSON.stringify(selectedAmenities));
  }, [selectedAmenities]);

  const handleNavigateWithParams = (step) => {
    navigate({ pathname: location.pathname, search: `?step=${step}` });
  };

  const [loading, setLoading] = useState(editVenue);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVenues = async () => {
      if (!isAuthenticated) {
        setError(new Error("No authentication token found. Please log in."));
        setLoading(false);
        return navigate("/");
      }
      try {
        const res = await fetch(`${baseUrl}/api/v1/attnd-venue/venues/${id}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            lang: getLangFromLocalStorage(),
          },
        });
        if (!res.ok) {
          if (res.status === 401) {
            navigate("/login");
            throw new Error("Unauthorized access. Please log in again.");
          }
          if (res.status === 404) {
            alert("404 Not found.");
            navigate(-1);
            throw new Error("404 Not found.");
          }
          throw new Error(res.statusText);
        }
        const venue = await res.json();
        const ids = (venue.venue_details.amenities || []).map((a) => a.id).filter((id) => id != null);
        setSelectedAmenities(ids);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (editVenue) fetchVenues();
  }, [baseUrl, editVenue, id, navigate]);

  if (loading) return (
    <div style={{ height: "calc(100vh - 400px)", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Loading />
    </div>
  );
  if (error) return <div className="venue-venues-container">Error fetching venue: {error.message}</div>;

  return (
    <div className="steps" style={editVenue ? { margin: "0" } : {}}>
      <CurrentStep step={4} />
      <div
        className="Nav"
        style={
          editVenue
            ? { alignItems: "flex-start", margin: "0", padding: "0", flexDirection: "column" }
            : { flexDirection: "column" }
        }
      >
        <div
          className="amenities"
          style={
            editVenue
              ? { margin: "0", padding: "0", flexDirection: "column" }
              : { flexDirection: "column" }
          }
        >
          <h5>{t("stepThree.amenitiesTitle")}</h5>
          <div className="amenities-content">
            {amenitiesList.map((amenity) => {
              const isSelected = selectedAmenities.includes(amenity.id);
              const lang = getLangFromLocalStorage();
              const displayName = lang === "ar" && amenity.name_ar ? amenity.name_ar : amenity.name;
              return (
                <div
                  key={amenity.id}
                  className="amenity"
                  style={{
                    background: isSelected ? "#6609F8" : "",
                    color: isSelected ? "#FFFFFF" : "",
                  }}
                  onClick={() => handleAmenityClick(amenity.id)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
                      fill={isSelected ? "#FFFFFF" : "#5507CF"}
                    />
                    <path
                      d="M12 18.75C11.59 18.75 11.25 18.41 11.25 18V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V18C12.75 18.41 12.41 18.75 12 18.75Z"
                      fill={isSelected ? "#FFFFFF" : "#5507CF"}
                    />
                  </svg>
                  <p>{displayName}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="buttons">
          <button className="Cancel" onClick={() => handleNavigateWithParams(3)}>
            {t("stepThree.previous") || "Previous"}
          </button>
          <button
            className="Next"
            onClick={() => {
              if (status === "loading") return;
              if (editVenue) update(null, selectedAmenities, null, null, id);
              else handleNavigateWithParams(5);
            }}
          >
            {editVenue
              ? status === "loading"
                ? t("stepThree.loading")
                : t("stepThree.save")
              : t("stepThree.next")}
          </button>
        </div>
      </div>
      {status === "Success" && (
        <div className="message_Venue">
          <div>
            <Success />
            {t("stepThree.changesSaved")}
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default StepThree;
